// import { gsap } from "gsap/gsap-core";
// import Swiper from "swiper/bundle";

/* global gsap, swiper: false */


const EFFECT_DURATION = 0.5;

export default class FullScreenSlider {
	constructor(swiper) {
		if (!swiper) return;
		this.swiper = swiper;
		this.section = this.swiper.closest(".flexible-section");
		this.slides = swiper.querySelectorAll(".swiper-slide");
		this.dataSettings = this.swiper.dataset.swiper;

		this.backgrounds = Array.from(
			this.section.querySelector(".backgrounds").querySelectorAll(".background")
		);

		if (0 === this.slides.length) return;
		this.init();
		this.events();
	}

	init() {
		const dataSettings =
			this.dataSettings &&
			this.dataSettings.length > 0 &&
			JSON.parse(this.dataSettings);

		this.swiper = new Swiper(this.swiper, dataSettings);

		new IntersectionObserver((entries, observer) => {
			if (entries[0].isIntersecting) {
				observer.disconnect();
				this.swiper.autoplay.start();
			}
		}).observe(document.querySelector('.section-full-screen-slider .swiper'));

		if (this.backgrounds) {
			this.backgrounds.map((el, index) => (el.style.zIndex = `-${index}`));
		}
	}

	events() {
		this.swiper.on("slideChange", (swiper) => {
			const newIdx = swiper.realIndex;
			const previousIdx = swiper.previousRealIndex;
			let bgsToMove = null;

			if (newIdx > previousIdx) {
				// move right
				bgsToMove = this.backgrounds.filter((el, index) => index < newIdx);

				gsap.to(bgsToMove, {
					duration: 1.4,
					x: "-100%",
				});
			} else {
				// move left
				bgsToMove = this.backgrounds.filter((el, index) => index >= newIdx);

				gsap.to(bgsToMove, {
					duration: 1.4,
					x: 0,
				});
			}
		});
	}
}
